import { MediaViewerPage } from '@jarvis/platform-ui';

export function ImageViewerPage() {
  return (
    <MediaViewerPage
      kind="image"
      filesLinkTo="/finance/secure-pharm-reports"
      filesLinkLabel="Secure Pharm Reports"
    />
  );
}
